//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {CustomGdprPopup} from '@nuskin/design-components';
import {NsIcon} from '@nuskin/ns-icon';
import {ProductCardsCarousel} from '@nuskin/product-components-vue';
import {events, dateFormatter, storage} from '@nuskin/ns-util';
import {
  CartService,
  AdrService,
  FavoritesService,
  ShopContextService,
  EquinoxCartService
} from '@nuskin/ns-shop';
import {EquinoxService} from '@nuskin/ns-account';
import {
  isNullOrEmpty,
  isArray,
  fromJsonString,
  getProp,
  getFullUrl
} from '@nuskin/ns-common-lib';
import {PriceType} from '@nuskin/ns-product-lib';
import pagedown from 'pagedown';
import {productLib} from '@nuskin/product-lib';
import {getStrings} from '../utils/stringUtils';
import {getMarketCurrency, parseOktaObject} from '../utils';
import {ProductStatus} from '../services/productStatus';

import PRODUCT_QUERY from '../queries/PRODUCT_QUERY.graphql';
import PRODUCT_BY_SKU_QUERY from '../queries/PRODUCT_BY_SKU_QUERY.graphql';

const PENDING_FAVORITE = 'pendingFavorite';

export default {
  name: 'ProductDetail',
  components: {NsIcon, ProductCardsCarousel, CustomGdprPopup},
  props: {
    slug: {
      type: String,
      required: true
    },
    variantSlug: {
      type: String,
      default: ''
    },
    scripts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      productData: {},
      bundleData: {}, // used as bundle computed prop
      bundleSkus: [], // selected mandatory && optional skus
      imageCarouselPosition: 0,
      productCardCarouselPosition: 0,
      // either BUY_ONCE or SUBSCRIPTION
      purchaseTypeSelect: 'BUY_ONCE',
      selectedVariantSku: '',
      canUserShop: true,
      maxQuantity: 0,
      quantity: 1,
      isFavorite: false,
      activeSalesEvents: [],
      salesEvent: '',
      maxQuantitySet: false,
      analyticsInterval: null,
      devModal: {},
      showDevModal: false,
      replacementProduct: null,
      replacementProductError: null,
      replacementProductLoading: false,
      showSubscriptionPrice: false,
      onLoad: true,
      showGdprBanner: false,
      gdprMessage: ''
    };
  },
  head() {
    return {
      title:
        this.product.seoInformation && this.product.seoInformation.metaTitle,
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            (this.product.seoInformation &&
              this.product.seoInformation.metaDescription) ||
            this.product.description
        },
        {
          hid: 'description',
          name: 'description',
          content:
            this.product.seoInformation &&
            this.product.seoInformation.metaDescription
        },
        {
          hid: 'title',
          name: 'title',
          content:
            this.product.seoInformation && this.product.seoInformation.metaTitle
        },
        {
          hid: 'twitter:image:alt',
          name: 'twitter:image:alt',
          content:
            this.product.seoInformation &&
            this.product.seoInformation.ogImage &&
            this.product.seoInformation.ogImage.alt !== ''
              ? this.product.seoInformation.ogImage.alt
              : (this.primaryImage || {}).alt
        },
        {
          hid: 'twitter:card',
          name: 'twitter:card',
          content:
            this.product.seoInformation &&
            this.product.seoInformation.ogImage &&
            this.product.seoInformation.ogImage.url !== ''
              ? this.product.seoInformation.ogImage.url
              : (this.primaryImage || {}).url
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content:
            this.product.seoInformation && this.product.seoInformation.metaTitle
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content:
            this.product.seoInformation &&
            this.product.seoInformation.ogImage &&
            this.product.seoInformation.ogImage.url !== ''
              ? this.product.seoInformation.ogImage.url
              : (this.primaryImage || {}).url
        },
        {
          hid: 'og:image:alt',
          property: 'og:image:alt',
          content:
            this.product.seoInformation &&
            this.product.seoInformation.ogImage &&
            this.product.seoInformation.ogImage.alt !== ''
              ? this.product.seoInformation.ogImage.alt
              : (this.primaryImage || {}).alt
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.sharingURL
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'Nu Skin'
        }
      ],
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: this.sharingURL
        }
      ]
    };
  },
  computed: {
    isDev() {
      return !!this.$store.getters['nuskin/isDev'];
    },
    environment() {
      // prod, test, or dev
      return this.$store.getters['nuskin/environment'];
    },
    isEquinoxMarket() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const contentSource = urlParams.get('contentSource');
      const configurationSdkIsEquinox = (
        (this.configuration || {}).Equinox_Markets || {}
      ).active;
      if (contentSource === 'Equinox') {
        return true;
      } else if (contentSource === 'CS') {
        return false;
      }
      return configurationSdkIsEquinox;
    },
    noLegacy() {
      return this.$route && typeof this.$route.query.mobile !== 'undefined';
    },
    market() {
      return this.$store.state.nuskin.market || '';
    },
    language() {
      let lang = this.$store.state.nuskin.language || '';
      if (lang.toUpperCase() === 'IN') {
        lang = 'id';
      }
      return lang;
    },
    marketConfig() {
      return this.$store.state.nuskin.marketConfig || {};
    },
    marketCurrency() {
      return getMarketCurrency(this.market);
    },
    configuration() {
      return this.$store.state.nuskin.configuration || {};
    },
    traditionalLocale() {
      return this.$store.getters['nuskin/traditionalLocale'] || '';
    },
    traditionalUrl() {
      return this.$store.getters['nuskin/traditionalUrl'] || '';
    },
    contentstackLocale() {
      return this.$store.getters['nuskin/contentstackLocale'] || '';
    },
    siteUrl() {
      return this.$store.getters['nuskin/siteUrl'] || '';
    },
    slugIsSku() {
      return (
        !!this.slug &&
        (!!this.slug.match(/^\d{8}$/g) ||
          !!(this.slug.startsWith('blt') && this.slug.length === 19) ||
          !!(this.slug.startsWith('GP') && this.slug.length === 8))
      );
    },
    userId() {
      return this.$store.state.user.userId;
    },
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
    isDistributor() {
      return this.$store.state.user.isDistributor;
    },
    isPreferredCustomer() {
      return this.$store.state.user.isPreferredCustomer;
    },
    user() {
      return this.$store.state.user.user;
    },
    userIsQualified() {
      return (
        this.isExclusive &&
        this.maxQuantity > 0 &&
        this.quantity <= this.maxQuantity
      );
    },
    // base product data
    product() {
      return this.productData || {};
    },
    // returns the selected variant's info, or the first one if it exists, or the product itself if no variants are found
    variant() {
      const variants = this.product.variants || [];
      const variant =
        (!!this.variantSlug &&
          variants.find((variant) => variant.slug === this.variantSlug)) ||
        variants.find((variant) => variant.sku === this.selectedVariantSku) ||
        variants.find((variant) => !!variant.matchingVariant) ||
        variants[0] ||
        this.product;
      // eslint-disable-next-line vue/no-async-in-computed-properties
      setTimeout(() => {
        this.setMaxQuantity();
      }, 25);
      return variant;
    },
    bundle() {
      return this.bundleData || {};
    },
    isBundle() {
      const isBundle =
        (!isNullOrEmpty(this.product.bundle) &&
          ['skuKit', 'kit', 'bundle'].includes(
            (this.product.bundle || {}).type
          )) ||
        (!isNullOrEmpty(this.bundle) &&
          ['skuKit', 'kit', 'bundle'].includes(this.bundle || {}).type) ||
        (!isNullOrEmpty(this.bundleData) &&
          ['skuKit', 'kit', 'bundle'].includes(this.bundleData || {}).type);
      return isBundle;
    },
    productDataSource() {
      return this.product.productDataSource || {};
    },
    salesLabel() {
      if (!this.salesEvent) {
        return '';
      }
      return this.isBundle
        ? this.bundle.salesLabel ||
            this.variant.salesLabel ||
            this.product.salesLabel ||
            ''
        : this.variant.salesLabel || this.product.salesLabel || '';
    },
    salesText() {
      if (!this.salesEvent) {
        return '';
      }
      return this.isBundle
        ? this.bundle.salesText ||
            this.variant.salesText ||
            this.product.salesText
        : this.variant.salesText || this.product.salesText || '';
    },
    activeEventDisclaimer() {
      if (!this.salesEvent) {
        return '';
      }
      return (
        this.variant.activeEventDisclaimer ||
        this.product.activeEventDisclaimer ||
        ''
      );
    },
    salesDisclaimer() {
      if (this.variant.salesDisclaimer) {
        return this.variant.salesDisclaimer;
      }
      if (this.product.salesDisclaimer) {
        return this.product.salesDisclaimer;
      }
      return null;
    },
    salesDisclaimerBody() {
      if (!this.salesDisclaimer) {
        return null;
      }

      const markdownLinkRegex = /\[(?<linkText>.*)\]\((?<linkUrl>.*)\)/;
      const markdownText = this.salesDisclaimer.replace(
        markdownLinkRegex,
        (...args) => {
          const {linkText, linkUrl} = args[args.length - 1];
          return `[${linkText}](${getFullUrl(this.siteUrl, linkUrl)})`;
        }
      );
      const safeConverter = pagedown.getSanitizingConverter();
      const html = safeConverter.makeHtml(markdownText);
      // open links in new tab
      const modifiedHtml = html.replaceAll('<a ', '<a target="_blank" ');
      return modifiedHtml;
    },
    productDetailsDescription() {
      let description = (this.variant.productDetails || {}).description;
      if (isNullOrEmpty(description) || description[0] === 'undefined') {
        description = (this.product.productDetails || {}).description;
      }
      return description;
    },
    productDetailsIncludedItems() {
      let included = (this.variant.productDetails || {}).includedItems;
      if (isNullOrEmpty(included)) {
        included = (this.product.productDetails || {}).includedItems;
      }
      return included || [];
    },
    productDetailsHighlights() {
      let highlights = (this.variant.productDetails || {}).highlights;
      if (isNullOrEmpty(highlights)) {
        highlights = (this.product.productDetails || {}).highlights;
      }
      return highlights || [];
    },
    hasValidDetails() {
      return (
        this.variant.legacyLongDescription ||
        !isNullOrEmpty(this.productDetailsDescription) ||
        !isNullOrEmpty(this.productDetailsIncludedItems) ||
        !isNullOrEmpty(this.productDetailsHighlights) ||
        (!isNullOrEmpty(this.selectedBundleVariants) && this.isBundle)
      );
    },
    availableQuantity() {
      if (this.isBundle) {
        return this.bundle.atpQuantity || 0;
      }
      return this.variant.atpQuantity || 0;
    },
    backorderQuantity() {
      if (this.isBundle) {
        return this.bundle.backorderQuantity || 0;
      }
      return this.variant.backorderQuantity || 0;
    },
    backorderedAvailableDate() {
      if (this.isBundle) {
        return this.bundle.backorderedAvailableDate || null;
      }
      return this.variant.backorderedAvailableDate || null;
    },
    productFeatures() {
      return (this.variant.features || []).length > 0
        ? this.variant.features[0]
        : (this.product.features || [])[0] || {};
    },
    // the active variant sku
    variantSku() {
      return this.variant.sku;
    },
    subscriptionOnly() {
      if (this.isBundle) {
        return (
          (this.bundle.purchaseTypes || {}).subscription &&
          !(this.bundle.purchaseTypes || {}).buyOnce
        );
      }
      return (
        (this.variant.purchaseTypes || {}).subscription &&
        !(this.variant.purchaseTypes || {}).buyOnce
      );
    },
    purchaseType() {
      if (this.subscriptionOnly) {
        return 'SUBSCRIPTION';
      } else {
        return this.purchaseTypeSelect;
      }
    },
    /**
     * If subscribeAndSave is true:
     * Display the subscription pricing from the graphql
     * Change the “Subscribe Monthly” button text to be the “Subscribe And Save”
     * text (common strings - product.subscribeAndSave)
     */
    subscribeAndSave() {
      if (this.isBundle) {
        return (this.bundle.purchaseTypes || {}).subscribeAndSave;
      }
      return (this.variant.purchaseTypes || {}).subscribeAndSave;
    },
    /**
     * If isActiveSubscriber is true:
     * Display subscription pricing from the graphql
     * If the subscription price is less than the buy once price
     * show the original retail/wholesale price crossed out and
     * show the buy once price to be the same as the subscription price
     */
    isActiveSubscriber() {
      if (this.isBundle) {
        return (this.bundle.purchaseTypes || {}).activeSubscriber;
      }
      return (this.variant.purchaseTypes || {}).activeSubscriber;
    },
    mobileAndPhablet() {
      return this.$mq === 'mobile' || this.$mq === 'phablet';
    },
    showLegacyBenefits() {
      return !!this.legacyBenefits;
    },
    showBenefits() {
      return (
        this.showLegacyBenefits ||
        (this.benefits.benefits && this.benefits.benefits !== '')
      );
    },
    legacyBenefits() {
      return (
        !this.noLegacy &&
        (this.variant.legacyBenefits || this.product.legacyBenefits)
      );
    },
    benefits() {
      if (
        (this.variant.benefits || {}).benefits &&
        this.variant.benefits.benefits !== ''
      ) {
        return this.variant.benefits;
      } else {
        return this.product.benefits || {};
      }
    },
    results() {
      const results = this.product.results || {};
      const varResults = this.variant.results || {};
      if (
        (varResults.results || []).length > 0 ||
        ((varResults.summary || []).length > 0 &&
          varResults.summary[0] !== null)
      ) {
        return varResults;
      } else {
        return results;
      }
    },
    showResults() {
      return (
        (this.results.results || []).length > 0 ||
        ((this.results.summary || []).length > 0 &&
          this.results.summary[0] !== null)
      );
    },
    sustainability() {
      const sustainability = this.product.sustainability;
      return sustainability;
    },
    showSustainability() {
      if (this.sustainability) {
        if (
          !this.sustainability.image &&
          !this.sustainability.youTubeVideoId &&
          !this.sustainability.description
        ) {
          return (
            !!this.sustainability.highlights &&
            this.sustainability.highlights.length > 0
          );
        }
        return true;
      }
      return false;
    },
    showUsage() {
      return (
        ((this.usage || {}).steps || []).length > 0 ||
        ((this.usage || {}).recommendations || []).length > 0 ||
        ((this.usage || {}).warnings || []).length > 0 ||
        ((this.usage || {}).additionalText || []).length > 0 ||
        (this.usage || {}).markdown
      );
    },
    usage() {
      if (
        this.isBundle &&
        (((this.bundle.usage || {}).steps || []).length > 0 ||
          ((this.bundle.usage || {}).recommendations || []).length > 0 ||
          ((this.bundle.usage || {}).warnings || []).length > 0 ||
          ((this.bundle.usage || {}).additionalText || []).length > 0 ||
          (this.bundle.usage || {}).markdown)
      ) {
        return this.bundle.usage;
      }
      if (
        ((this.variant.usage || {}).steps || []).length > 0 ||
        ((this.variant.usage || {}).recommendations || []).length > 0 ||
        ((this.variant.usage || {}).warnings || []).length > 0 ||
        ((this.variant.usage || {}).additionalText || []).length > 0 ||
        (this.variant.usage || {}).markdown
      ) {
        return this.variant.usage;
      }
      return this.product.usage;
    },
    showLegacyIngredients() {
      return (
        !this.noLegacy &&
        ((!!this.product.legacyIngredients &&
          this.product.legacyIngredients.length > 0) ||
          (!!this.variant.legacyIngredients &&
            this.variant.legacyIngredients.length > 0))
      );
    },
    ingredients() {
      const varIngs = this.checkIngredients(this.variant.ingredients);
      const prodIngs = this.checkIngredients(this.product.ingredients);
      if (varIngs) {
        return isArray(this.variant.ingredients)
          ? this.variant.ingredients
          : [this.variant.ingredients];
      }
      if (prodIngs) {
        return isArray(this.product.ingredients)
          ? this.product.ingredients
          : [this.product.ingredients];
      }
      return [];
    },
    showIngredients() {
      return this.showLegacyIngredients || this.ingredients.length > 0;
    },
    showLegacyResources() {
      try {
        // If it's a JSON object, return false (it's an array which will be in this.resources)
        JSON.parse(this.legacyResources);
        return false;
      } catch (error) {
        // is HTML content
        return (
          (this.resources || []).length === 0 &&
          this.legacyResources &&
          this.legacyResources.length > 0
        );
      }
    },
    showResources() {
      return (
        // this.isDistributor &&
        this.showLegacyResources || (this.resources || []).length > 0
      );
    },
    resources() {
      if (
        this.selectedBundleVariants &&
        (this.selectedBundleVariants || []).length > 0 &&
        this.isBundle
      ) {
        const resources = [];
        this.selectedBundleVariants.forEach((v) => {
          resources.push(...v.resources);
        });
        if ((this.product.resources || []).length > 0) {
          resources.push(...this.product.resources);
        }
        const filtered = this.filterDuplicate(resources, false, 'url');
        if (filtered.length) {
          return filtered;
        }
      }
      return (this.variant.resources || []).length > 0
        ? this.variant.resources
        : this.product.resources;
    },
    legacyResources() {
      if (this.noLegacy) {
        return [];
      }
      if (this.variant.legacyResources) {
        if (this.variant.legacyResources.length > 0)
          return this.variant.legacyResources;
      }
      return this.product.legacyResources;
    },
    showFaqs() {
      return (this.faqs || []).length > 0;
    },
    faqs() {
      return (this.variant.faqs || []).length > 0
        ? this.variant.faqs
        : this.product.faqs;
    },
    generalDisclaimer() {
      return this.$t('generalDisclaimer');
    },
    disclaimers() {
      if (
        this.selectedBundleVariants &&
        (this.selectedBundleVariants || []).length > 0 &&
        this.isBundle
      ) {
        const disclaimers = [];
        this.selectedBundleVariants.forEach((v) => {
          disclaimers.push(...v.disclaimers);
        });
        if ((this.product.disclaimers || []).length > 0) {
          disclaimers.push(...this.product.disclaimers);
        }
        const filtered = this.filterDuplicate(disclaimers, true);
        if (filtered.length) {
          return filtered;
        }
      }
      return (this.variant.disclaimers || []).length
        ? this.variant.disclaimers
        : this.product.disclaimers || [];
    },
    disclaimerWarnings() {
      if (
        this.selectedBundleVariants &&
        (this.selectedBundleVariants || []).length > 0
      ) {
        const disclaimerWarnings = [];
        this.selectedBundleVariants.forEach((v) => {
          disclaimerWarnings.push(...v.disclaimerWarnings);
        });
        if ((this.product.disclaimerWarnings || []).length > 0) {
          disclaimerWarnings.push(...this.product.disclaimerWarnings);
        }
        const filtered = this.filterDuplicate(
          disclaimerWarnings,
          false,
          'markdown'
        );
        if (filtered.length) {
          return filtered;
        }
      }
      return (this.variant.disclaimerWarnings || []).length
        ? this.variant.disclaimerWarnings
        : this.product.disclaimerWarnings || [];
    },
    showDisclaimers() {
      return (
        this.generalDisclaimer ||
        this.disclaimers.length ||
        this.disclaimerWarnings.length
      );
    },
    isPersonalOffer() {
      return !!this.$store.getters['nuskin/isPersonalOffer'];
    },
    hideSubscription() {
      return (
        !!this.$store.getters['nuskin/hideSubscription'] &&
        !this.isActiveSubscriber &&
        !this.subscribeAndSave
      );
    },
    showWholeSalePricing() {
      return !!this.$store.getters['nuskin/showWholesalePricing'];
    },
    isWholesale() {
      if (
        !this.isDistributor &&
        !this.isPreferredCustomer &&
        this.showWholeSalePricing &&
        this.isLoggedIn
      ) {
        return false;
      }
      return (
        this.isDistributor ||
        this.isPreferredCustomer ||
        this.showWholeSalePricing
      );
    },
    isExclusive() {
      if (this.isBundle) {
        return !!this.bundle.isExclusive;
      }
      return !!this.variant.isExclusive;
    },
    points() {
      const pointsKey = this.isWholesale ? 'wholesale' : 'retail';
      if (this.isBundle) {
        return this.salesEvent
          ? ((this.bundle.points || {})[this.salesEvent] || {})[pointsKey]
          : (this.bundle.points || {})[pointsKey];
      }
      return this.salesEvent
        ? ((this.variant.points || {})[this.salesEvent] || {})[pointsKey]
        : (this.variant.points || {})[pointsKey];
    },
    price() {
      const priceKey = this.isWholesale ? 'wholesale' : 'retail';
      if (this.isBundle) {
        return this.salesEvent
          ? ((this.bundle.price || {})[this.salesEvent] || {})[priceKey]
          : (this.bundle.price || {})[priceKey];
      }
      return this.salesEvent
        ? ((this.variant.price || {})[this.salesEvent] || {})[priceKey]
        : (this.variant.price || {})[priceKey];
    },
    currency() {
      if (this.isBundle) {
        if ((this.bundle.price || {}).currencyCode) {
          return this.bundle.price.currencyCode;
        } else if (
          this.selectedBundleVariants &&
          this.selectedBundleVariants[0] &&
          this.selectedBundleVariants[0].pricingJson
        ) {
          return (
            (JSON.parse(this.selectedBundleVariants[0].pricingJson).prices ||
              [])[0] || {}
          ).currency;
        }
      }
      return (
        this.variant.price || {currencyCode: this.marketCurrency || 'USD'}
      ).currencyCode;
    },
    originalPrice() {
      if (
        (this.subscriptionPrice < this.price && this.isActiveSubscriber) ||
        (this.isBundle &&
          this.bundleSubscriptionPrice < this.bundle.price &&
          this.isActiveSubscriber)
      ) {
        return this.price; // so we can show this price crossed out when its an active subscriber
      }
      if (this.isBundle) {
        return this.isWholesale || this.salesEvent
          ? (this.bundle.price || {}).retail
          : null;
      }
      return this.isWholesale || this.salesEvent
        ? (this.variant.price || {}).retail
        : null;
    },
    subscriptionPrice() {
      const priceKey = this.isWholesale
        ? 'wholesaleSubscription'
        : 'retailSubscription';
      if (this.isBundle && ((this.bundle || {}).price || {})[priceKey]) {
        return (this.bundle.price || {})[priceKey];
      }
      return (this.variant.price || {})[priceKey];
    },
    bundleSubscriptionPrice() {
      const priceKey = this.isWholesale
        ? 'wholesaleSubscription'
        : 'retailSubscription';
      if (this.isBundle) {
        return (this.bundle.price || {})[priceKey];
      }
      return null;
    },
    priceLabel() {
      if (this.salesEvent) {
        return this.isWholesale
          ? this.$t('price.wholesaleSales')
          : this.$t('price.retailSales');
      }
      return this.isWholesale
        ? this.$t('price.wholesale')
        : this.$t('price.retail');
    },
    priceType() {
      if (this.salesEvent) {
        return this.isWholesale ? 'wholesaleSales' : 'retailSales';
      }
      return this.isWholesale ? 'wholesale' : 'retail';
    },
    originalPriceLabel() {
      if (this.isActiveSubscriber && this.isWholesale) {
        return this.$t('price.wholesale');
      } else if (this.isActiveSubscriber) {
        return this.$t('price.retail');
      }
      if (this.isWholesale || this.salesEvent) {
        return this.$t('price.retail');
      }
      return '';
    },
    originalPriceType() {
      if (this.isActiveSubscriber && this.isWholesale) {
        return 'wholesale';
      } else if (this.isActiveSubscriber) {
        return 'retail';
      }
      if (this.isWholesale || this.salesEvent) {
        return 'retail';
      }
      return '';
    },
    subscriptionPriceLabel() {
      return this.$t('price.subscription');
    },
    statusKey() {
      const statusKey = 'status';
      const bundleStatus =
        this.isBundle &&
        this.bundle.status &&
        (this.bundle.status || {})[statusKey]
          ? (this.bundle.status || {})[statusKey]
          : null;
      const status = bundleStatus || (this.variant.status || {})[statusKey];
      if (status === ProductStatus.Sellable) {
        if (bundleStatus) {
          if ((this.bundle.status || {}).inventory === 'backordered') {
            return 'onBackorder';
          } else if ((this.bundle.status || {}).inventory === 'outOfStock') {
            return 'outOfStock';
          }
        }
        if ((this.variant.status || {}).inventory === 'backordered') {
          return 'onBackorder';
        }
        if ((this.variant.status || {}).inventory === 'outOfStock') {
          return 'outOfStock';
        }
        if (this.isExclusive && this.availableQuantity === 0) {
          return 'reachedPurchaseLimit';
        }
        if (
          this.backorderedAvailableDate &&
          this.quantity > this.availableQuantity &&
          this.backorderQuantity
        ) {
          return 'onBackorder';
        }
      } else if (status === ProductStatus.Discontinued) {
        return 'discontinued';
      } else if (status === ProductStatus.Inactive) {
        return 'notReleasedForSale';
      } else if (status === ProductStatus.Stopped) {
        return 'stopStatus';
      } else if (status === ProductStatus.BundleOnly) {
        return 'notSoldSeperately';
      }
      return 'releasedForSale';
    },
    statusType() {
      const statusKey = 'status';
      if (
        this.isBundle &&
        this.bundle.status &&
        (this.bundle.status || {})[statusKey]
      ) {
        return (this.bundle.status || {})[statusKey];
      }
      return (this.variant.status || {})[statusKey];
    },
    statusMessage() {
      const statusKey = this.statusKey;
      switch (statusKey) {
        case 'onBackorder':
          return this.$t('status.onBackorder').replace(
            '%date%',
            dateFormatter.getCountryFormattedDate(
              this.backorderedAvailableDate,
              this.traditionalLocale
            )
          );
        case 'reachedPurchaseLimit':
          return this.$t('status.reachedPurchaseLimit');
        case 'outOfStock':
          return this.$t('status.outOfStock');
        case 'discontinued':
          return this.$t('status.discontinued');
        case 'notReleasedForSale':
          return this.$t('status.notReleasedForSale');
        case 'stopStatus':
          return this.$t('status.stopStatus');
        case 'notSoldSeperately':
          return this.$t('status.notSoldSeperately');
        default:
          return '';
      }
    },
    shippingMessage() {
      return this.$t('shipping.message');
    },
    refundLink() {
      const link = this.$t('refund.linkUrl');
      if (link && link !== 'refund.linkUrl') {
        return link;
      }
      return null;
    },
    warranty() {
      if (
        this.product &&
        this.product.warranty &&
        this.product.warranty.length > 0
      ) {
        return this.product.warranty;
      }
      return false;
    },
    showSubscriptions() {
      const isMessage = !['subscriptions.message', ''].includes(
        this.$t('subscriptions.message')
      );
      const isTriggerText = !['subscriptions.triggerText', ''].includes(
        this.$t('subscriptions.triggerText')
      );

      return isMessage && isTriggerText;
    },
    primaryImage() {
      if ((this.variant.productImages || []).length > 0) {
        const image = {
          url: this.variant.productImages[0].url,
          alt: this.variant.productImages[0].alt
        };
        return image;
      } else {
        return {};
      }
    },
    thirdPartyScripts() {
      return [
        ...(this.scripts || []),
        ...(this.product.thirdPartyScripts || [])
      ];
    },
    sharingURL() {
      const url = window.location.href
        .replace(`/${this.slug}`, `/${this.product.slug || this.sku}`)
        .replace(`/${this.sku}`, `/${this.product.slug || this.sku}`);
      return url;
    },
    bundleImages() {
      if (!this.isBundle) {
        return this.variant.productImages;
      }
      if (
        (this.bundle || {}).kitProducts &&
        ((this.bundle || {}).kitProducts || []).length < 1
      ) {
        return this.variant.productImages;
      }

      const kitProducts = ((this.bundle || {}).kitProducts || []).map((kp) => {
        return kp.product;
      });
      const imgs = kitProducts.map((kp) => {
        if (
          kp.variants &&
          kp.variants[0] &&
          kp.variants[0].productImages &&
          kp.variants[0].productImages[0]
        ) {
          return kp.variants[0].productImages[0];
        }
        return null;
      });
      return [...this.variant.productImages, ...imgs];
    },
    selectedBundleVariants() {
      if (!this.isBundle) {
        return null;
      }
      if (
        (this.bundle || {}).kitProducts &&
        ((this.bundle || {}).kitProducts || []).length < 1
      ) {
        return null;
      }

      const kitProducts = ((this.bundle || {}).kitProducts || []).map((kp) => {
        // assign kit products quantity to each variant so it's easy to grab it
        // and display the quantity along with the variant title under "This kit contains"
        kp.product.variants.forEach((variant) => {
          variant.bundleQty = kp.quantity;
          variant.parentProductSlug = kp.product.slug;
        });
        return kp.product;
      });
      const kitProductVariants = kitProducts.map((p) => {
        return p.variants;
      });
      const variantArrays = kitProductVariants.map((vs) => {
        return vs.filter((v) => this.bundleSkus.includes(v.sku));
      });
      const arraysOfSelectedVariants = variantArrays.filter((arrOfVariants) => {
        return arrOfVariants && arrOfVariants.length > 0;
      });
      const selectedVariants = arraysOfSelectedVariants.map((v) => {
        return v[0];
      });
      this.setMaxQuantity();
      return selectedVariants;
    },
    discontinuedProduct() {
      if (this.isBundle && this.bundle) {
        return this.bundle.variants?.some(
          (v) =>
            v.discontinuedSkuReplacement && v.status.status === 'discontinued'
        );
      } else if (this.variant) {
        return (
          !!this.variant.discontinuedSkuReplacement &&
          this.variant.status.status === 'discontinued'
        );
      } else if (this.product && this.product.variants) {
        return this.product.variants.some(
          (v) =>
            v.discontinuedSkuReplacement && v.status.status === 'discontinued'
        );
      }
      return false;
    },
    currentReplacementSku() {
      let replacementSku = null;

      if (this.isBundle && this.bundle) {
        const variant = this.bundle.variants?.find(
          (v) => v.sku === this.selectedVariantSku
        );
        replacementSku = variant?.discontinuedSkuReplacement;
      } else if (this.variant) {
        replacementSku = this.variant.discontinuedSkuReplacement;
      } else if (this.product && this.selectedVariantSku) {
        const variant = this.product.variants.find(
          (v) => v.sku === this.selectedVariantSku
        );
        replacementSku = variant?.discontinuedSkuReplacement;
      }

      return replacementSku;
    },
    replacementProductImage() {
      return (
        this.replacementProduct?.variants?.[0]?.productImages?.[0]?.url || ''
      );
    },
    redirectToReplacementProduct() {
      return `${window.location.origin}/catalog/${this.market}/${this.language}/product/${this.variant.discontinuedSkuReplacement}`;
    },
    replacementProductTitle() {
      return this.replacementProduct?.title || '';
    },
    replacementProductName() {
      return this.replacementVariantSku(this.replacementProduct).title || '';
    },
    replacementProductDescription() {
      return (
        this.replacementVariantSku(this.replacementProduct).description || ''
      );
    },
    replaceProdcuctPrice() {
      const replacementVariant = this.replacementVariantSku(
        this.replacementProduct
      );
      return replacementVariant?.price?.retail || null;
    },
    replacementProductPrice() {
      const price = this.isWholesale
        ? this.replacementVariantSku(this.replacementProduct).price?.wholesale
        : this.replacementVariantSku(this.replacementProduct).price?.retail;
      return Intl.NumberFormat(this.currencyLocale || 'en-US', {
        style: 'currency',
        currency: this.currency || 'USD',
        currencyDisplay: 'narrowSymbol'
      }).format(price === 'object' ? 0 : price || 0);
    },
    currencyLocale() {
      return this.$store.getters['nuskin/currencyLocale'] || '';
    },
    replacementVariantData() {
      return this.replacementVariantSku(this.replacementProduct);
    },
    replacementProductData() {
      const variant = this.replacementVariantSku(this.replacementProduct) || {};
      return {
        sku: variant.sku || '',
        imageLink: this.replacementProductImage,
        href: this.redirectToReplacementProduct,
        title: this.replacementProductTitle,
        productName: this.replacementProductName,
        description: this.replacementProductDescription,
        price: this.replacementProductPrice
      };
    },
    gdprMarketConfig() {
      return (
        this.$store.state.nuskin.marketConfig.enablePrivateBrowsing || false
      );
    }
  },
  watch: {
    // when the sku changes, go to first image, and update variant selector
    variantSku: {
      immediate: true,
      handler(value) {
        this.imageCarouselPosition = 0;
        this.selectedVariantSku = value || '';
        this.setPricing(); // sales price maintained after variant selection change
      }
    },
    selectedVariantSku(variantSku) {
      if (variantSku) {
        this.setIsFavorite();
        this.setPricing();
        if (this.onLoad) {
          this.pushProductDetailImpression();
          this.onLoad = false;
        }
      }
    },
    currentReplacementSku: {
      immediate: true,
      async handler(replacementSku) {
        if (!replacementSku) {
          this.resetReplacementProduct();
          return;
        }
        await this.loadReplacementProduct(replacementSku);
      }
    }
  },
  async mounted() {
    this.addListeners();
    this.getGdprCustomMessage();
    await this.setCanUserShopInMarket();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    async setCanUserShopInMarket() {
      this.canUserShop = await CartService.canUserAddToCart();
    },
    async getGdprCustomMessage() {
      try {
        const value = await getStrings();
        this.gdprMessage = value.join(' ');
        if (this.gdprMarketConfig) {
          this.showGdprBanner = true;
        }
      } catch (error) {
        console.error('Error fetching GDPR message:', error);
      }
    },
    resetReplacementProduct() {
      this.replacementProductError = new Error(
        'No replacement product available'
      );
      this.replacementProductLoading = false;
      this.replacementProduct = null;
    },

    async loadReplacementProduct(replacementSku) {
      this.replacementProductLoading = true;
      try {
        const {data} = await this.$apollo.query({
          query: PRODUCT_BY_SKU_QUERY,
          variables: {
            id: replacementSku,
            market: this.market.toLowerCase(),
            language: this.language.toLowerCase()
          }
        });

        if (!data?.productById?.variants?.length) {
          throw new Error('Replacement product not found');
        }

        this.replacementProduct = data.productById;
        this.replacementProductError = null;
      } catch (error) {
        this.replacementProductError = error;
        this.replacementProduct = null;
      } finally {
        this.replacementProductLoading = false;
      }
    },
    handleChange(option) {
      this.showSubscriptionPrice = option;
    },
    getVariant(sku) {
      return this.product.variants.find((variant) => variant.sku === sku);
    },

    getPriceType() {
      if (this.isWholesale) {
        return PriceType.WWHL;
      }
      return this.isLoggedIn
        ? ShopContextService.getPriceType(false, this.user)
        : PriceType.WRTL;
    },

    convertMarkdown(paragraph) {
      const safeConverter = pagedown.getSanitizingConverter();
      const html = safeConverter.makeHtml(paragraph);
      const modifiedHtml = html.replaceAll('<a ', '<a target="_blank" ');
      return modifiedHtml;
    },

    checkIngredients(ingredients) {
      if (isNullOrEmpty(ingredients)) {
        return false;
      }

      if (!isArray(ingredients)) {
        ingredients = [ingredients];
      }

      for (const productIngredients of ingredients) {
        for (const [key, value] of Object.entries(productIngredients)) {
          if (key !== '__typename' && !isNullOrEmpty(value)) {
            return true;
          }
        }
      }

      return false;
    },

    /**
     * Filter Duplicate Objects from Array
     * @param {[]} arr - Array of objects
     * @param {Boolean} isArrOfStrings - if array of strings, remove duplicate strings, not duplicate objects
     * @param {String} key - one of the object keys string value, one of the keys within every object of the arr to check for duplicates
     */
    filterDuplicate(arr, isArrOfStrings, Objkey) {
      if (isArrOfStrings) {
        const seen = {};
        const out = [];
        const len = arr.length;
        let j = 0;
        for (let i = 0; i < len; i++) {
          const item = arr[i];
          if (seen[item] !== 1) {
            seen[item] = 1;
            out[j++] = item;
          }
        }
        return out;
      }
      if ((arr || []).length > 0 && Objkey) {
        const lookup = {};
        arr.forEach((element) => {
          lookup[element[Objkey]] = element;
        });
        return Object.keys(lookup).map((key) => lookup[key]);
      }
      if ((arr || []).length === 1) {
        return arr;
      }
      return [];
    },

    handleQuantityChange(quantity) {
      this.quantity = quantity;
    },

    replacementVariantSku(productToUse) {
      if (productToUse?.variants?.length > 0) {
        const matchingVariant = productToUse.variants.find(
          (variant) => variant.sku === this.variant.discontinuedSkuReplacement
        );

        if (matchingVariant) {
          return matchingVariant;
        }

        return productToUse.variants[0];
      }

      return null;
    },

    async handleAddToCart() {
      // Check if replacementProduct has data
      const replacementProductAvailable =
        this.replacementProduct &&
        Object.keys(this.replacementProduct).length > 0 &&
        this.discontinuedProduct;
      const productToUse = replacementProductAvailable
        ? this.replacementProduct
        : this.product;
      if (replacementProductAvailable) {
        this.quantity = 1;
      }

      let productSkuId = this.selectedVariantSku || this.bundle.id;
      if (replacementProductAvailable) {
        productSkuId = this.replacementVariantSku(productToUse).sku;
      }

      const maxProductQuantity = replacementProductAvailable
        ? productToUse.variants?.[0].maxQuantity
        : this.maxQuantity;

      if (this.quantity > maxProductQuantity) {
        return;
      }
      if (this.isEquinoxMarket) {
        const bundle = productToUse.bundle;
        const skuId = this.isBundle ? productToUse.id : this.selectedVariantSku;
        const imageURL =
          this.bundleImages && this.bundleImages[0] && this.bundleImages[0].url
            ? this.bundleImages[0].url
            : null;

        const isSubscription =
          this.purchaseType === 'SUBSCRIPTION' &&
          !AdrService.isAdrOverride() &&
          !replacementProductAvailable;
        const options = {
          qty: Number(this.quantity),
          adr: isSubscription,
          subscription: isSubscription
            ? {frequencyPeriod: '1', frequencyType: 'MONTHS'}
            : null,
          product: {
            equinoxProductId: productToUse.id,
            title: productToUse.title,
            sku: productSkuId,
            properties: {
              categoryId: 'all_products',
              imageURL,
              name: productToUse.title,
              productId: productSkuId,
              slug: productToUse.slug
            }
          }
        };

        if ((this.isBundle || productToUse.bundle) && bundle.kitProducts) {
          const type = bundle.type === 'skuKit' ? 'SKUKIT' : 'BUNDLE';
          const childSkus = [
            {
              productId: productToUse.id,
              skuId,
              type
            }
          ];
          for (const kitProduct of bundle.kitProducts) {
            const product = kitProduct.product || {};
            const variants = product.variants || [];
            if (
              variants.some((v) =>
                this.bundleSkus.map((s) => s).includes(v.sku)
              )
            ) {
              // for BUNDLES
              const variant =
                (variants.filter((v) => this.bundleSkus.includes(v.sku)) ||
                  [])[0] || variants[0];
              const type =
                !this.isBundle || kitProduct.isMandatory === true
                  ? 'MANDATORY'
                  : 'OPTIONAL';
              childSkus.push({
                inventory: {
                  backOrdered: variant.status.inventory === 'backordered'
                },
                productId: kitProduct.product.id,
                skuId: variant.sku,
                skuQuantity: variant.bundleQty,
                type
              });
            }
            options.product.childSkus = childSkus;
            const isBackordered =
              ((this.bundle || {}).status || {}).inventory === 'backordered' ||
              (this.quantity > this.availableQuantity &&
                this.backorderedAvailableDate);
            options.product.inventory = isBackordered ? 'BACKORDER' : '';
          }
          // Regular product with variant/s
        } else {
          const isBackordered =
            ((this.variant || {}).status || {}).inventory === 'backordered' ||
            (this.quantity > this.availableQuantity &&
              this.backorderedAvailableDate);
          options.product.inventory = isBackordered ? 'BACKORDER' : '';
        }
        try {
          await EquinoxCartService.addProductToEquinoxCart(options);
          console.log('EQ Product added');
          this.maxQuantity -= options.qty;
          events.publish(events.shop.SHOW_ADD_TO_BAG, options);
          this.$nuxt.$emit('show-cart-toast', {
            equinoxQtyOverride: true,
            amount: this.quantity,
            productName: replacementProductAvailable
              ? productToUse.title
              : this.variant.title
          });
        } catch (error) {
          console.error('Failed to add to cart.', error);
          this.$nuxt.$emit('show-failed-cart-toast', {
            productName: replacementProductAvailable
              ? productToUse.title
              : this.variant.title
          });
        }
      } else {
        const options = {
          sku: productSkuId,
          qty: this.quantity,
          userId: this.userId,
          cntryCd: this.market,
          language: this.language,
          isAdr:
            this.purchaseType === 'SUBSCRIPTION' &&
            !AdrService.isAdrOverride() &&
            !replacementProductAvailable,
          isPitchCart: this.isPersonalOffer,
          referrer: 'productPage',
          domain: window.location.hostname
        };

        try {
          storage.setItem(storage.metadata.CUSTOM_EVENT_PAYLOAD, {
            catalogAddToCart: true,
            category: this.variant?.productType,
            brand: 'Nuskin',
            variant: '',
            item_type: replacementProductAvailable
              ? 'replacement_product'
              : 'Standard'
          });
          await CartService.addSkuToCart(options);
          this.maxQuantity -= options.qty;
          events.publish(events.shop.SHOW_ADD_TO_BAG, options);

          this.$nuxt.$emit('show-cart-toast', {
            amount: this.quantity,
            productName: productToUse.title
          });
        } catch (error) {
          console.error('Failed to add to cart.', error);
          this.$nuxt.$emit('show-failed-cart-toast', {
            productName: productToUse.title
          });
        }
      }
    },

    setPricing() {
      if (!this.selectedVariantSku && !this.isBundle) {
        return;
      }

      let salesEvent = '';

      if (this.isBundle) {
        const bundlePrice = this.bundle.price || {};
        if (
          !isNullOrEmpty(bundlePrice.retailSales) ||
          !isNullOrEmpty(bundlePrice.wholesaleSales)
        ) {
          this.bundle.price.salesEvent = {
            retail: (this.bundle.price || {}).retailSales,
            wholesale: (this.bundle.price || {}).wholesaleSales
          };
          if (!isNullOrEmpty(this.bundle.points)) {
            this.bundle.points.salesEvent = {
              wholesale: {
                cv: (this.bundle.points.wholesale || {}).cv,
                pv: (this.bundle.points.wholesale || {}).pv
              }
            };
          }

          this.salesEvent = 'salesEvent';
          return;
        }
      }

      const variantPrice = this.variant.price || {};
      if (
        !isNullOrEmpty(variantPrice.retailSales) ||
        !isNullOrEmpty(variantPrice.wholesaleSales)
      ) {
        this.variant.price.salesEvent = {
          retail: this.variant.price.retailSales,
          wholesale: this.variant.price.wholesaleSales
        };
        if (!isNullOrEmpty(this.variant.points)) {
          this.variant.points.salesEvent = {
            wholesale: {
              cv: (this.variant.points.wholesale || {}).cv,
              pv: (this.variant.points.wholesale || {}).pv
            }
          };
        }

        this.salesEvent = 'salesEvent';
        return;
      }

      const pricing = fromJsonString(this.variant.pricingJson, {});

      for (const activeSalesEvent of this.activeSalesEvents) {
        // get sales event pricing
        let retailPrice = getProp(
          pricing,
          `retail.${activeSalesEvent}.price`,
          null
        );
        retailPrice = isNullOrEmpty(retailPrice) ? null : retailPrice;

        let wholesalePrice = getProp(
          pricing,
          `wholesale.${activeSalesEvent}.price`,
          null
        );
        wholesalePrice = isNullOrEmpty(wholesalePrice) ? null : wholesalePrice;

        let wholesaleCv = getProp(
          pricing,
          `wholesale.${activeSalesEvent}.cv`,
          null
        );
        wholesaleCv = isNullOrEmpty(wholesaleCv) ? null : wholesaleCv;

        let wholesalePv = getProp(
          pricing,
          `wholesale.${activeSalesEvent}.pv`,
          null
        );
        wholesalePv = isNullOrEmpty(wholesalePv) ? null : wholesalePv;

        if (retailPrice || wholesalePrice || wholesaleCv || wholesalePv) {
          this.variant.price[activeSalesEvent] = {
            retail: retailPrice,
            wholesale: wholesalePrice
          };

          if (!this.variant.points) {
            this.variant.points = {};
          }
          this.variant.points[activeSalesEvent] = {
            wholesale: {
              cv: wholesaleCv,
              pv: wholesalePv
            }
          };
          salesEvent = activeSalesEvent;
        }
      }

      this.salesEvent = salesEvent;
    },

    async setMaxQuantity() {
      if (this.isBundle) {
        try {
          this.maxQuantity = this.bundle.maxQuantity || this.availableQuantity;
        } catch (error) {
          this.maxQuantity = 0;
        } finally {
          this.maxQuantitySet = true;
        }
      } else {
        if (!this.selectedVariantSku) {
          return;
        }

        try {
          let productQuantity = 999;
          if (this.productDataSource.source !== 'equinox') {
            productQuantity = await CartService.getAddToCartQty(
              this.selectedVariantSku
            );
          }

          this.maxQuantity = Math.min(
            this.variant.maxQuantity || 0,
            productQuantity
          );
        } catch (error) {
          this.maxQuantity = 0;
          console.error('Failed to retrieve add to cart quantity.', error);
        } finally {
          this.maxQuantitySet = true;
        }
      }
    },

    /**
     * This function is being watched, will be invoked on page load and on variant selection change.
     * Does nothing if user is logged out.
     * If user is logged in and a pending sku exists -> attempt to add it for both legacy and equinox markets and
     * update state accordingly.
     * If user is logged in and no pending sku exists -> check if item is favorited or not in the API and
     * update state accordingly for both legacy and equinox markets.
     */
    async setIsFavorite() {
      this.isFavorite = false;
      if (!this.selectedVariantSku) {
        return;
      }
      let pending = JSON.parse(localStorage.getItem(PENDING_FAVORITE)) || null;
      const sku = this.isEquinoxMarket
        ? this.product.id
        : this.selectedVariantSku;
      if (pending && pending.sku !== sku) {
        localStorage.setItem(PENDING_FAVORITE, JSON.stringify({sku}));
        pending = JSON.parse(localStorage.getItem(PENDING_FAVORITE)) || null;
      }
      if (this.isLoggedIn && pending && pending.sku === sku) {
        if (this.isEquinoxMarket) {
          try {
            await EquinoxService.getOrCreateFavorites();
          } catch (error) {
            console.error(
              'Favorites Service getOrCreateFavorites() within setIsFavorite() failed: ',
              error
            );
          }
          try {
            await FavoritesService.addToFavorites(sku);
          } catch (error) {
            console.error(
              'Favorites Service addToFavorites() within setIsFavorite() failed: ',
              error
            );
          }
          try {
            await FavoritesService.getFavoritesFromServer();
          } catch (error) {
            console.error(
              'Favorites Service getFavoritesFromServer() within setIsFavorite() failed: ',
              error
            );
          }
        }
        this.isFavorite = true;
        localStorage.removeItem(PENDING_FAVORITE);
      } else if (this.isLoggedIn) {
        if (this.isEquinoxMarket) {
          try {
            await EquinoxService.getOrCreateFavorites();
          } catch (error) {
            console.error(
              'Equinox Service getOrCreateFavorites() within setIsFavorite() failed: ',
              error
            );
          }
          try {
            await FavoritesService.getFavoritesFromServer();
          } catch (error) {
            console.error(
              'Equinox Service getFavoritesFromSErver() within setIsFavorite() failed: ',
              error
            );
          }
        }
        try {
          await FavoritesService.isInFavorites(sku).then((data) => {
            this.isFavorite = data;
          });
        } catch (error) {
          console.error(
            'Favorites Service isInFavorites() within setIsFavorite() failed: ',
            error
          );
        }
      }
    },

    /**
     * Adds/Removes product to favorites, or requests authentication
     * Will update isFavorite state
     */
    async handleFavoriteClick() {
      if (!this.selectedVariantSku) {
        return;
      }
      const sku = this.isEquinoxMarket
        ? this.product.id
        : this.selectedVariantSku;
      if (this.isLoggedIn) {
        if (this.isFavorite) {
          if (this.isEquinoxMarket) {
            try {
              await EquinoxService.getOrCreateFavorites();
            } catch (error) {
              console.error(
                'Favorites Service getOrCreateFavorites within handleFavoriteClick() failed: ',
                error
              );
            }
            try {
              await FavoritesService.getFavoritesFromServer();
            } catch (error) {
              console.error(
                'Favorites Service getFavoritesFromServer within handleFavoriteClick() failed: ',
                error
              );
            }
          }
          try {
            await FavoritesService.removeFromFavorites(sku);
          } catch (error) {
            console.error(
              'Favorites Service removeFromFavorites within handleFavoriteClick() failed: ',
              error
            );
          }
        } else {
          if (this.isEquinoxMarket) {
            try {
              await EquinoxService.getOrCreateFavorites();
            } catch (error) {
              console.error(
                'Favorites Service getOrCreateFavorites within handleFavoriteClick() failed: ',
                error
              );
            }
            try {
              await FavoritesService.getFavoritesFromServer();
            } catch (error) {
              console.error(
                'Favorites Service getFavoritesFromServer within handleFavoriteClick() failed: ',
                error
              );
            }
          }
          try {
            await FavoritesService.addToFavorites(sku);
          } catch (error) {
            console.error(
              'Favorites Service addToFavorites within handleFavoriteClick() failed: ',
              error
            );
          }
        }
        this.isFavorite = !this.isFavorite;
        this.$emit('favorite-click', {
          sku,
          isFavorite: this.isFavorite
        });
      } else {
        localStorage.setItem(PENDING_FAVORITE, JSON.stringify({sku}));
        events.publish(events.authentication.REQUEST_FOR_LOGIN, {
          href: window.location.href
        });
      }
    },

    handleActiveSalesEvents(activeSalesEvents) {
      this.activeSalesEvents = activeSalesEvents || [];
      this.setPricing();
      this.setMaxQuantity();
    },

    handleProductStatusResult(productStatusResult) {
      let queryAgain = false;
      if (this.isBundle && ((this.bundle || {}).status || {}).status) {
        this.bundleUpdate();
      } else {
        for (const productStatus of productStatusResult) {
          const variant = this.getVariant(productStatus.SKU);
          if (!isNullOrEmpty(variant)) {
            queryAgain = true;
          }
        }
        if (queryAgain) {
          this.$apollo.queries.productData.skip = false;
          this.$apollo.queries.productData.refetch();
          this.setPricing();
          this.setMaxQuantity();
        }
      }
    },

    handleQualificationStatusChanged() {
      if (this.isBundle && ((this.bundle || {}).status || {}).status) {
        this.bundleUpdate();
      } else {
        this.setMaxQuantity();
      }
    },

    handleBadProductRedirect() {
      if (
        this.isEquinoxMarket &&
        !(
          window.location.href.includes('mysite') ||
          window.location.href.includes('mynuskin')
        )
      ) {
        // redirect to https://test.nuskin.com/us/en/search/keyword%20anotherkeyword etc
        // instead of https://test.nuskin.com/content/nuskin/en_US/home.html?productQuery=skuandorslug
        const equinoxSearchUrl = new URL(
          this.siteUrl +
            `/${this.market.toLowerCase()}/${this.language.toLowerCase()}/search/${encodeURIComponent(
              this.slug
            )}`
        );
        this.devModal['Redirect URL'] = equinoxSearchUrl;
        if (this.isDev) {
          console.warn(
            `[Catalog] (DEV) Redirecting to '${equinoxSearchUrl.href}'...`
          );
        }
        window.location = equinoxSearchUrl.href;
      } else {
        const traditionalUrl = new URL(this.traditionalUrl);
        traditionalUrl.searchParams.set('productQuery', this.slug);
        this.devModal['Redirect URL'] = traditionalUrl;
        if (this.isDev) {
          console.warn(
            `[Catalog] (DEV) Redirecting to '${traditionalUrl.href}'...`
          );
        }
        window.location = traditionalUrl.href;
      }
    },

    pushProductDetailImpression() {
      const replacementProductAvailable =
        this.replacementProduct &&
        Object.keys(this.replacementProduct).length > 0;
      const productToUse = replacementProductAvailable
        ? this.replacementProduct
        : this.product;
      const event = {
        event: events.shop.PRODUCT_IMPRESSION_DETAIL,
        ecommerce: {
          detail: {
            actionField: {
              list: '',
              action: 'detail'
            },
            products: [
              {
                id: this.variant.sku,
                name: this.variant.title,
                price: this.price,
                // getting category from ContentStack,if null displaying 'Nu Skin' as the default value
                category:
                  productToUse.categories?.[0]?.displayName || 'Nu Skin',
                brand: 'Nuskin',
                replacement_product: this.discontinuedProduct
                  ? 'available'
                  : 'not available',
                // TODO: we currently pass the variant sku as the id, unsure if this is what the GA people want
                item_type:
                  this.variant.status.status === 'discontinued'
                    ? 'discontinued'
                    : 'Standard'
              }
            ]
          }
        },
        platform: 'Legacy'
      };
      this.$store.commit('nuskin/pushGoogleAnalyticsEvent', event);
    },

    async bundleUpdate({...updates}) {
      if (!this.isBundle) {
        return;
      }
      const newSkuFoundInBundleSkus = !!this.bundleSkus.find(
        (sku) => sku === (updates || {}).newSku
      );
      const oldSkuFoundInBundleSkus = !!this.bundleSkus.find(
        (sku) => sku === (updates || {}).oldSku
      );
      if (updates.isRemoveOldSku && oldSkuFoundInBundleSkus) {
        const index = this.bundleSkus.indexOf((updates || {}).oldSku);
        this.bundleSkus.splice(index, 1);
      }
      if ((updates || {}).isAddNewSku && !newSkuFoundInBundleSkus) {
        this.bundleSkus.push((updates || {}).newSku);
      }

      const product = await productLib.getProduct({
        data: this.product,
        market: this.market,
        language: this.language,
        env: this.environment
      });

      const okta = parseOktaObject(sessionStorage.oktaTokens);

      const pricing = await product.getPricing(
        (updates || {}).bundleQuantity || this.quantity,
        okta,
        null,
        this.bundleSkus
      );
      const attributes = product.updateBundleAttributes(this.bundleSkus);

      const currencyCode = this.currency;

      if (isNullOrEmpty(product.data) || isNullOrEmpty(pricing)) {
        console.error(
          'ERROR updating bundle pricing!\n',
          'Here is the product data response from product-lib:\n',
          product,
          '\n',
          'Here is the product pricing response from product-lib:',
          pricing
        );
      }

      const bundle = {
        ...this.bundleData,
        price: {...(pricing || {}).price, currencyCode},
        points: (pricing || {}).points,
        promotions: (pricing || {}).promotions,
        availableQuantity: (attributes || {}).atpQuantity,
        atpQuantity: (attributes || {}).atpQuantity,
        dangerousGoods: (attributes || {}).dangerousGoods,
        maxQuantity: (attributes || {}).maxQuantity,
        backorderedAvailableDate:
          ((attributes || {}).status || {}).backorderedAvailableDate || null,
        status: {
          backorderedAvailableDate:
            ((attributes || {}).status || {}).backorderedAvailableDate || null,
          isBackordered:
            ((attributes || {}).status || {}).isBackordered || false,
          status: ((attributes || {}).status || {}).status || '',
          inventory: ((attributes || {}).status || {}).inventory
        }
      };
      console.debug(
        'product-libs new bundle product data after updating its selected skus: ',
        (product || {}).data
      );
      this.bundleData = {...bundle};
      this.setMaxQuantity();
      this.setPricing();
    },

    bundleLink(bundleVariant, translation) {
      const linkText = translation.substring(
        translation.indexOf('%') + 1,
        translation.lastIndexOf('%')
      );
      const market = (this.market || 'US').toLowerCase();
      const productSlug = (bundleVariant || {}).parentProductSlug;
      const variantSku = (bundleVariant || {}).sku;
      const variantSlug = (bundleVariant || {}).slug;
      const mainSlug = productSlug || variantSku;
      const slug =
        variantSlug && variantSlug !== productSlug
          ? mainSlug + '?variant=' + variantSlug
          : mainSlug;
      const link = `
        <a href="${window.location.origin}/catalog/${market}/${this.language}/product/${slug}">
          ${linkText}
        </a>`;
      const html = `<p><span>${
        (bundleVariant || {}).title
      }&nbsp;</span>${translation.replace(`%${linkText}%`, link)}</p>`;
      return html;
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      events.getValue(
        events.salesevent.ACTIVE_EVENTS,
        this.handleActiveSalesEvents,
        true // subscribe
      );

      // listen to product status changes
      events.subscribe(
        events.shop.PRODUCT_STATUS_RESULT,
        this.handleProductStatusResult
      );

      // get latest qualification status, listen to changes
      events.getValue(
        events.shop.QUALIFICATION_STATUS_CHANGED,
        this.handleQualificationStatusChanged,
        true // subscribe
      );
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      // stop listening to active sales events
      events.unsubscribe(
        events.salesevent.ACTIVE_EVENTS,
        this.handleActiveSalesEvents
      );

      // stop listening to product status changes
      events.unsubscribe(
        events.shop.PRODUCT_STATUS_RESULT,
        this.handleProductStatusResult
      );

      // stop listening to qualification status changes
      events.unsubscribe(
        events.shop.QUALIFICATION_STATUS_CHANGED,
        this.handleQualificationStatusChanged
      );
    },

    getMatchingVariantOrFirstSku(variants) {
      for (const variant of variants) {
        if (variant.matchingVariant) {
          return variant.sku;
        }
      }
      return variants[0].sku;
    }
  },
  apollo: {
    productData: {
      query() {
        return this.slugIsSku ? PRODUCT_BY_SKU_QUERY : PRODUCT_QUERY;
      },
      variables() {
        const params = {
          // locale: this.contentstackLocale
          market: this.market.toLowerCase(),
          language: this.language.toLowerCase()
        };
        if (this.slugIsSku) {
          params.id = this.slug;
        } else {
          params.slug = this.slug;
        }

        params.useContentSource = null;
        const sourceParam = this.$route.query.contentSource;
        if (this.isDev) params.useContentSource = 'CS';
        if (sourceParam && (sourceParam === 'CS' || sourceParam === 'Equinox'))
          params.useContentSource = sourceParam;
        params.quantity = 1;
        params.okta = parseOktaObject(sessionStorage.oktaTokens);
        return params;
      },
      update: (data) => {
        return data.productBySlug || data.productById;
      },
      result({data, loading, networkStatus}) {
        const product = data.productBySlug || data.productById;
        if (this.isDev && !loading) {
          console.debug('[Catalog] (DEV) Product Data:', data);
        }
        if (
          !product ||
          ((!product.variants || product.variants.length < 1) &&
            !product.bundle)
        ) {
          if (this.isDev) {
            console.warn(
              "[Catalog] (DEV) Product doesn't exist or is misconfigured. GraphQL Response:",
              data
            );
            this.devModal['GraphQL Response'] = data;

            if (
              this.isEquinoxMarket &&
              !(
                window.location.href.includes('mysite') ||
                window.location.href.includes('mynuskin')
              )
            ) {
              // redirect to https://test.nuskin.com/us/en/search/keyword%20anotherkeyword etc
              // instead of https://test.nuskin.com/content/nuskin/en_US/home.html?productQuery=skuandorslug
              const equinoxSearchUrl = new URL(
                this.siteUrl +
                  `/${this.market.toLowerCase()}/${this.language.toLowerCase()}/search/${encodeURIComponent(
                    this.slug
                  )}`
              );
              this.devModal['Redirect URL'] = equinoxSearchUrl;
            } else {
              const traditionalUrl = new URL(this.traditionalUrl);
              traditionalUrl.searchParams.set('productQuery', this.slug);
              this.devModal['Redirect URL'] = traditionalUrl;
            }

            this.showDevModal = true;

            return product;
          } else {
            this.handleBadProductRedirect();
          }
        } else {
          // if (
          //   (!product.variants || product.variants.length < 1) &&
          //   product.bundle &&
          //   product.bundle.type !== 'bundle' // i.e. sku kits
          // ) {
          //   product.variants = SkuKitToVariant(product);
          //   return product;
          // }
          if (!isNullOrEmpty(product.bundle)) {
            this.bundleData = product.bundle;
            const mandatoryKitProducts = [];
            const mandatoryKitProductVariants = [];
            // gather mandatory kit products
            if (
              product.bundle.kitProducts &&
              product.bundle.kitProducts.length > 0
            ) {
              product.bundle.kitProducts.forEach(
                (kitProduct) =>
                  kitProduct.isMandatory === true &&
                  mandatoryKitProducts.push(kitProduct.product)
              );
            }
            // gather mandatory kit product variants, initially just the first variant of each product
            if (mandatoryKitProducts && mandatoryKitProducts.length > 0) {
              mandatoryKitProducts.forEach(
                (product) =>
                  product.variants &&
                  product.variants.length > 0 &&
                  mandatoryKitProductVariants.push(
                    this.getMatchingVariantOrFirstSku(product.variants)
                  )
              );
            }
            this.bundleSkus = mandatoryKitProductVariants;
          }
          this.setPricing();
          return product;
        }
      },
      error(error) {
        if (error.networkError) {
          console.error(`Network error: ${JSON.stringify(error)}`);
          this.$apollo.queries.productData.refetch();
        }
        if (this.isDev) {
          console.error(
            '[Catalog] (DEV) Failure getting Product Data. Error:',
            error
          );
          this.devModal['GraphQL Error'] = error;
          this.showDevModal = true;
        }
      }
    }
  }
};
